var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.463,
    height: 22,
    viewBox: "0 0 21.463 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6159",
    "data-name": "Group 6159",
    transform: "translate(10.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47435",
    "data-name": "Path 47435",
    d: "M26.794,11a9.826,9.826,0,0,0-.322-2.5l1.242-.914L25.3,3.413l-1.414.62a9.74,9.74,0,0,0-4.326-2.5L19.393,0h-4.82L14.4,1.532a9.74,9.74,0,0,0-4.326,2.5l-1.414-.62L6.252,7.587,7.494,8.5a9.872,9.872,0,0,0,0,5l-1.242.914,2.41,4.175,1.414-.62a9.739,9.739,0,0,0,4.326,2.5L14.573,22h4.82l.17-1.532a9.74,9.74,0,0,0,4.326-2.5l1.414.62,2.41-4.175L26.473,13.5a9.828,9.828,0,0,0,.322-2.5ZM19.542,9.524l.921-.9L22.82,11.03l-2.407,2.357-.9-.921L21,11.011ZM16.7,15.487l-1.261-.266,1.833-8.708,1.261.266Zm-2.242-3.021-.9.921-2.407-2.357L13.5,8.622l.921.9L12.969,11.01Z",
    transform: "translate(-17)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiWhite);
export default __webpack_public_path__ + "static/media/api-white.cf919b3b2963be26c0f515a47e9e511e.svg";
export { ForwardRef as ReactComponent };